var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("AppNavigation", {
    scopedSlots: _vm._u([
      {
        key: "list",
        fn: function() {
          return [
            _vm._l(_vm.getPersons, function(p, index) {
              return _c(
                "AppNavigationItem",
                {
                  key: index,
                  class: index === _vm.activePersonId ? "active-person" : "",
                  attrs: {
                    title: p.name,
                    "allow-collapse": true,
                    open: index === 0 ? true : false,
                    icon: "icon-user",
                    editable: true,
                    "edit-label": _vm.t("health", "edit name")
                  },
                  on: {
                    "update:menuOpen": function($event) {
                      _vm.menuOpenPersonId = index
                    },
                    "update:title": _vm.personUpdateName,
                    click: function($event) {
                      _vm.$store.dispatch("setActivePerson", index)
                      _vm.$store.dispatch("setActiveModule", "person")
                    }
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "actions" },
                    [
                      _c(
                        "ActionButton",
                        {
                          attrs: {
                            "close-after-click": true,
                            icon: "icon-details"
                          },
                          on: {
                            click: function($event) {
                              _vm.$store.commit("showSidebar", true)
                              _vm.$store.dispatch("setActivePerson", index)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.t("health", "Show details")) +
                              "\n\t\t\t\t"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "ActionButton",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.personsLength != 1,
                              expression: "personsLength != 1"
                            }
                          ],
                          attrs: {
                            "close-after-click": true,
                            icon: "icon-delete"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$store.dispatch(
                                "deletePerson",
                                _vm.persons[_vm.menuOpenPersonId]
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.t("health", "Delete")) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  p.enabledModuleWeight
                    ? _c("AppNavigationItem", {
                        class:
                          _vm.activeModule === "weight" &&
                          index === _vm.activePersonId
                            ? "active-module"
                            : "",
                        attrs: {
                          title: _vm.t("health", "Weight"),
                          icon: "icon-quota"
                        },
                        on: {
                          click: function($event) {
                            _vm.$store.dispatch("setActivePerson", index)
                            _vm.$store.dispatch("setActiveModule", "weight")
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  p.enabledModuleFeeling
                    ? _c("AppNavigationItem", {
                        class:
                          _vm.activeModule === "feeling" &&
                          index === _vm.activePersonId
                            ? "active-module"
                            : "",
                        attrs: {
                          title: _vm.t("health", "Feeling"),
                          icon: "icon-category-monitoring"
                        },
                        on: {
                          click: function($event) {
                            _vm.$store.dispatch("setActivePerson", index)
                            _vm.$store.dispatch("setActiveModule", "feeling")
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  p.enabledModuleMeasurement
                    ? _c("AppNavigationItem", {
                        class:
                          _vm.activeModule === "measurement" &&
                          index === _vm.activePersonId
                            ? "active-module"
                            : "",
                        attrs: {
                          title: _vm.t("health", "Measurement"),
                          icon: "icon-home"
                        },
                        on: {
                          click: function($event) {
                            _vm.$store.dispatch("setActivePerson", index)
                            _vm.$store.dispatch(
                              "setActiveModule",
                              "measurement"
                            )
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  p.enabledModuleSleep
                    ? _c("AppNavigationItem", {
                        class:
                          _vm.activeModule === "sleep" &&
                          index === _vm.activePersonId
                            ? "active-module"
                            : "",
                        attrs: {
                          title: _vm.t("health", "Sleep"),
                          icon: "icon-download"
                        },
                        on: {
                          click: function($event) {
                            _vm.$store.dispatch("setActivePerson", index)
                            _vm.$store.dispatch("setActiveModule", "sleep")
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  p.enabledModuleSmoking
                    ? _c("AppNavigationItem", {
                        class:
                          _vm.activeModule === "smoking" &&
                          index === _vm.activePersonId
                            ? "active-module"
                            : "",
                        attrs: {
                          title: _vm.t("health", "Smoking"),
                          icon: "icon-address"
                        },
                        on: {
                          click: function($event) {
                            _vm.$store.dispatch("setActivePerson", index)
                            _vm.$store.dispatch("setActiveModule", "smoking")
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  p.enabledModuleActivities
                    ? _c("AppNavigationItem", {
                        class:
                          _vm.activeModule === "activities" &&
                          index === _vm.activePersonId
                            ? "active-module"
                            : "",
                        attrs: {
                          title: _vm.t("health", "Activities"),
                          icon: "icon-upload"
                        },
                        on: {
                          click: function($event) {
                            _vm.$store.dispatch("setActivePerson", index)
                            _vm.$store.dispatch("setActiveModule", "activities")
                          }
                        }
                      })
                    : _vm._e()
                ],
                2
              )
            }),
            _vm._v(" "),
            _c(
              "AppNavigationItem",
              {
                attrs: {
                  title: _vm.t("health", "New person"),
                  icon: "icon-add",
                  pinned: false
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    _vm.showNewPersonForm = true
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showNewPersonForm,
                        expression: "showNewPersonForm"
                      }
                    ],
                    staticClass: "person-create"
                  },
                  [
                    _c(
                      "form",
                      {
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.createPerson($event)
                          }
                        }
                      },
                      [
                        _c("input", {
                          ref: "newPersonName",
                          attrs: {
                            placeholder: _vm.t("health", "Name"),
                            type: "text",
                            required: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "icon-confirm",
                          attrs: { type: "submit", value: "" }
                        }),
                        _vm._v(" "),
                        _c(
                          "Actions",
                          [
                            _c("ActionButton", {
                              staticClass: "ab-integrated",
                              attrs: { icon: "icon-close" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.closeNewPersonForm($event)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }